// Angular
import { Injectable, Renderer2 } from '@angular/core';



// Services
import { ApiService } from './api.service';
import { CacheService } from './../utils/cache.service';

// Resources
import { Resource } from './base/resource';


@Injectable()
export class ToastUtilsService extends Resource {

    renderer: Renderer2;

    constructor(
        cache: CacheService,
        api: ApiService,
    ) {
        super(cache, api, 'toast-utils');
    }


    setToastMode(success: boolean, rnd: Renderer2) {
        this.renderer = rnd;
        if (success) {
            this.addClassBody('uni-toast--global-ok');
            this.removeClassBody('uni-toast--global-ko');
        } else {
            this.removeClassBody('uni-toast--global-ok');
            this.addClassBody('uni-toast--global-ko');
        }
    }

    addClassBody(nameClass: string) {
        this.renderer.addClass(document.body, nameClass);
    }

    removeClassBody(nameClass: string) {
        this.renderer.removeClass(document.body, nameClass);
    }

}
